import { useTranslations } from '@vocab/react';
import { Box, Text } from 'braid-design-system';
import React from 'react';

import translations from './.vocab';

import * as styles from './index.css';

export const BarLabel = () => {
  const { t } = useTranslations(translations);
  return (
    <Box display="flex" className={styles.barLabel} marginBottom="xsmall">
      <Box flexGrow={1}>
        <Text weight="strong" align="center" size="xsmall">
          {t('bar-label-low-text')}
        </Text>
      </Box>
      <Box flexGrow={1}>
        <Text weight="strong" align="center" size="xsmall">
          {t('bar-label-average-text')}
        </Text>
      </Box>
      <Box flexGrow={1}>
        <Text weight="strong" align="center" size="xsmall">
          {t('bar-label-high-text')}
        </Text>
      </Box>
    </Box>
  );
};
